import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@emotion/react";

import Theme from "../../../../theme";
import store from "../../../../state-management/store";

import Popup from "./Popup";
import { IPopupProps } from "./Popup.types";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";

export const renderPopup = (props: IPopupProps): HTMLDivElement => {
  const node = document.createElement("div");
  const gtmParams = { id: "GTM-5T2S9J" };

  ReactDOM.render(
    <GTMProvider state={gtmParams}>
      <ThemeProvider theme={Theme.CE_THEME}>
        <Provider store={store}>
          <Popup {...props} />
        </Provider>
      </ThemeProvider>
    </GTMProvider>,
    node
  );

  return node;
};
